import { Injectable } from '@angular/core';
import { RequestService } from './request.service';
import { Prescription } from '../models/prescription.model';
import { MedicalOrder } from '../models/medical-order.model';
import { Call } from '../models/call.model';
import { MedicinePrescription } from '../models/medicine-prescription.model';
import { PrescriptionGeneratorService } from '../enums/prescription-generator-service.enum';

@Injectable({
  providedIn: 'root'
})
export class CallService {
  constructor(private requestService: RequestService) {}

  getOne(callId: string, populate?: string[], params: Record<string, unknown> = {}): Promise<Call> {
    return this.requestService.get('/call/' + callId, { populate, ...params });
  }

  update(callId: string, body: any): Promise<void> {
    return this.requestService.put('/call/' + callId, body);
  }

  createPrescription(body: {
    call: string;
    medicines?: MedicinePrescription[];
    prolongedTreatment?: boolean;
    sendDuplicates?: boolean;
    isPrescription: boolean;
    generatorService?: PrescriptionGeneratorService;
    generatorPrescriptionIds?: string[];
  }): Promise<Prescription[]> {
    return this.requestService.post('/prescription', body);
  }

  createMedicalOrder(body: { call: string; medicalOrders: MedicalOrder[] }): Promise<MedicalOrder[]> {
    return this.requestService.post('/medicalorder?checkDuplicatedDiagnosis=false', body);
  }

  notifyToSendFilesByWhatsApp(callId: string, data: any): Promise<any> {
    return this.requestService.post('/call/' + callId + '/sendFilesTemplate', data);
  }

  patientHasRepeatedAbsenteeism(patientId: string): Promise<boolean> {
    return this.requestService.get(`/call/patient/${patientId}/repeatedAbsenteeism`);
  }

  getPatientCalls(callId: string, skip: number, limit: number, count = false): Promise<{ data: Call[]; total: number } | Call[]> {
    return this.requestService.get(`/call/${callId}/patientCalls`, { skip, limit, ...(count && { count }) });
  }

  getPrescriptionPdf(callId: string, prescriptionId: string): Promise<{ url: string }> {
    return this.requestService.get(`/call/${callId}/prescriptionPdf/${prescriptionId}`);
  }

  updateExternalPrescriptionStatusToDeleted(callId: string, prescriptionId: string): Promise<void> {
    return this.requestService.put(`/call/${callId}/prescription/${prescriptionId}`, {});
  }
}
